<template>
    <v-navigation-drawer stateless value="true">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="addUser">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list v-if="getUsers.length > 0" class="v-list--booking">
            <v-list-item
                :key="user.id"
                v-for="user in getUsers"
                @click="editUser(user.id)"
                :class="`v-list--booking_state ${$route.params.userId === user.id ? 'active' : ''}`">
                <v-list-item-title>{{ user.name }}</v-list-item-title>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'userNavigation',
        components: { Empty },
        methods: {
            addUser () {
                this.$router.push({ name: 'addUser' })
            },
            editUser (userId) {
                this.$router.push({
                    name: 'editUser',
                    params: { userId }
                })
            }
        },
        computed: mapGetters([
            'getUsers'
        ])
    }
</script>
